module.exports = __webpack_public_path__ + "img/homeTag-icon-8.6e12c4a5.svg";